function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
const SvgProfile = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 64,
  height: 64,
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: props.className || ''
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M37.164 39.388v.27a7.164 7.164 0 0 0 7.164 7.164H45.5c4.137 0 7.49 3.395 7.49 7.532m-41.983-.041a7.49 7.49 0 0 1 7.49-7.49h1.17a7.164 7.164 0 0 0 7.165-7.165v-.27M62.5 32c0 16.845-13.655 30.5-30.5 30.5S1.5 48.845 1.5 32 15.155 1.5 32 1.5 62.5 15.155 62.5 32ZM31.999 14.157c7.223 0 13.08 5.856 13.08 13.08s-5.857 13.08-13.08 13.08c-7.224 0-13.08-5.856-13.08-13.08s5.856-13.08 13.08-13.08Z",
  stroke: "#116B6B",
  strokeWidth: 3
}));
export default SvgProfile;